import { Link } from 'react-router-dom';

interface CategoryCard {
  key: string;
  label: string;
  icon: string;
  desc: string;
  color: string;
}

const categories: CategoryCard[] = [
  {
    key: 'movie',
    label: '电影',
    icon: 'ri-movie-2-line',
    desc: '最新院线大片 · 经典佳片',
    color: 'from-red-500/80 to-orange-500/80',
  },
  {
    key: 'tv',
    label: '电视剧',
    icon: 'ri-tv-line',
    desc: '热播剧集 · 高分神剧',
    color: 'from-amber-500/80 to-yellow-500/80',
  },
  {
    key: 'variety',
    label: '综艺',
    icon: 'ri-emotion-laugh-line',
    desc: '热门综艺 · 欢笑不断',
    color: 'from-emerald-500/80 to-teal-500/80',
  },
  {
    key: 'ranking',
    label: '排行榜',
    icon: 'ri-bar-chart-line',
    desc: '影视榜单 · 实时更新',
    color: 'from-violet-500/80 to-purple-500/80',
  },
];

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6 max-w-7xl mx-auto">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.key}
            to={cat.key === 'ranking' ? '/category/movie' : `/category/${cat.key}`}
            className="relative overflow-hidden rounded-xl h-36 md:h-44 group cursor-pointer"
          >
            <div className={`absolute inset-0 bg-gradient-to-br ${cat.color} opacity-80 group-hover:opacity-100 transition-opacity duration-300`}></div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            <div className="relative z-10 h-full flex flex-col justify-end p-5">
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-background-50/20 backdrop-blur-sm rounded-xl mb-3">
                <i className={`${cat.icon} text-background-50 text-xl`}></i>
              </div>
              <h3 className="text-background-50 font-bold text-lg md:text-xl font-heading">{cat.label}</h3>
              <p className="text-background-50/70 text-xs mt-1">{cat.desc}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}